import { Link } from 'react-router-dom';
import { getLatestArticles } from '@/mocks/articles';

export default function ArticleSection() {
  const latestArticles = getLatestArticles();

  return (
    <section className="bg-background-100/70 py-10 md:py-14">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="flex items-end justify-between mb-6 md:mb-8">
          <div>
            <div className="flex items-center gap-2 mb-1">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-newspaper-line text-secondary-500 text-sm"></i>
              </div>
              <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">影视资讯</h2>
            </div>
            <p className="text-sm text-foreground-500 ml-7">最新影视动态和行业热点</p>
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-200 group cursor-pointer"
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-[10px] font-medium rounded-md whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-[10px] text-foreground-400">{article.date}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2">{article.summary}</p>
                <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-100">
                  <span className="text-[10px] text-foreground-400">{article.author}</span>
                  <span className="text-[10px] text-foreground-300">
                    <i className="ri-eye-line mr-0.5"></i>
                    {article.readCount.toLocaleString()}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}